import { MCBPS030CreateRequest } from 'types/MCBPS030/MCBPS030CreateRequest'
import request from 'utils/request'

// 画面を表示する
export const initApi = () =>
  request({
    url: `/MCBPS030/init`,
    method: 'post'
  })

// ”アップロード履歴を確認する”ボタン押下
export const historyConfirmApi = () =>
  request({
    url: `/MCBPS030/historyConfirm`,
    method: 'post'
  })

export const insertApi = (param: MCBPS030CreateRequest) => {
  const formData = new FormData()
  formData.append("uploadFiletmp", param.uploadFile)
  formData.append('jsonData', encodeURIComponent(JSON.stringify(param)))
  return request({
    url: `/MCBPS030/insert`,
    method: 'post',
    data: formData
  })
}